export default {
      id: "file-upload-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#file-upload",
      toString: function () {
        return this.url;
      }
    }